export default class AnimatingObserver {
    constructor() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add("is-animating");
                    this.observer.unobserve(entry.target);
                }
            });
        });
        this.elements = document.querySelectorAll(".will-animate");
        this.elements.forEach((element) => {
            this.observer.observe(element);
        });
    }
}